import ContactForm from "../../../components/ContactForm";
import Section from "../../../components/Section";
import SectionLayout from "../../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../../components/DeclarationBox";
import DeclarationBoxItem from "../../../components/DeclarationBoxItem";
import DeclarationModal from "../../../components/DeclarationModal";

import Variables from "../../../variables/variables.json";
import BackButton from "../../../components/BackButton";

import Nieruchomosci from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-1_pl.mdx";
import DeclarationBoxIndividual from "../../../components/DeclarationBoxIndividual";
import BackgroundSection from "../../../components/BackgroundSection";
import SectionBox from "../../../components/SectionBox";
import CustomListWithZero from "../../../components/CustomListWithZero";
import FAQ from "../../../components/FAQ";
import FloatVideo from "../../../components/FloatVideo";

import DrukIN11 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/druk-in-1/section-1_pl.mdx";
import DrukIN12 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/druk-in-1/section-2_pl.mdx";
import DrukIN13 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/druk-in-1/section-3_pl.mdx";
import DrukIN14 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/druk-in-1/section-4_pl.mdx";
import DrukIN15 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/druk-in-1/section-5_pl.mdx";
import DrukIN16 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/druk-in-1/section-6_pl.mdx";

export default function DrukIN1(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "drukin1";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx>
				<DrukIN11 />
			</Section>

			<Section mdx lighterdark noPanel>
				<DrukIN12 />
			</Section>

			<Section bigPaddingTop>
				<div className="declaration-box-individual__columns">
					<DeclarationBoxIndividual podatek="in1" top noReadMore btnPrimary button="link" />
					<DeclarationBoxIndividual podatek="dn1notin1" noShadow noAction />
				</div>
			</Section>

			<Section mdx>
				<DrukIN13 />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="drukin1"
				attachment
				textAlign="left"
				button="primary"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section mdx>
				<DrukIN14 />
			</Section>

			<Section mdx lighterdark>
				<DrukIN15 />

				<CustomListWithZero miasto={Miasto} section="drukin1" />

				<br />

				<DrukIN16 />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="drukin1"
				attachment
				textAlign="left"
				button="primary"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section title="sections.czestozadawanepytania.title" id="czesto-zadawane-pytania-faq">
				<FAQ miasto={Miasto} section="drukin1" secondary />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijinformacje.title">
				<DeclarationBox center>
					<DeclarationBoxItem miasto={Miasto} podatek={Podatek} noReadMore />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} podatek={Podatek} />
			</Section>

			<Section>
				<BackButton />
			</Section>

			<FloatVideo config="in1" />
		</SectionLayout>
	);
}
